import { observer } from 'mobx-react-lite';
import { ComponentProps, ReactElement } from 'react';

export const EvaluationIcon = observer(
  (props: ComponentProps<'svg'>): ReactElement => (
    <svg
      {...props}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
    >
      <path d='M20.992 18.266l-5.66-8.305V2.668H16A.67.67 0 0016.668 2 .67.67 0 0016 1.332H8.055a.668.668 0 100 1.336h.613v7.293l-5.613 8.246a2.853 2.853 0 00-.52 2 2.82 2.82 0 002.797 2.461h13.242a2.911 2.911 0 002.094-.8 2.82 2.82 0 00.324-3.602zM10 10.328v-7.66h4v7.66l3.434 5.004H6.566zm0 0' />
    </svg>
  )
);
